import { withInstall } from '@element-plus/utils'

import Popconfirm from './src/popconfirm.vue'

export const ElPopconfirm = withInstall(Popconfirm)
export default ElPopconfirm

export * from './src/popconfirm'
